/**
 * Debug utility to check subscription status
 * Usage: In browser console, run: window.debugSubscription('hanssackstark@gmail.com')
 */

import { firestore } from '../firebase';
import subscriptionManager from './subscriptionManager';

export async function debugSubscription(email) {
  console.log('🔍 Debugging subscription for:', email);
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

  try {
    // 1. Clear cache to force fresh read
    console.log('1️⃣ Clearing subscription cache...');
    subscriptionManager.clearCache(email);

    // 2. Try to read directly from Firestore
    console.log('2️⃣ Reading from Firestore directly...');
    const subscriptionDoc = await firestore
      .collection('subscriptions')
      .doc(email)
      .get();

    if (!subscriptionDoc.exists) {
      console.error('❌ No subscription document found in Firestore!');
      console.log('Expected document path:', `subscriptions/${email}`);
      return {
        error: 'Document does not exist',
        path: `subscriptions/${email}`,
      };
    }

    const docData = subscriptionDoc.data();
    console.log('✅ Document found! Data:', docData);

    // 3. Check field values
    console.log('3️⃣ Checking field values...');
    console.log('   - subscriptionStatus:', docData.subscriptionStatus);
    console.log('   - tier:', docData.tier);
    console.log('   - stripeCustomerId:', docData.stripeCustomerId);
    console.log('   - subscriptionId:', docData.subscriptionId);
    console.log('   - email:', docData.email);

    // 4. Check if conditions are met for premium
    console.log('4️⃣ Checking premium conditions...');
    const isPremium = docData.subscriptionStatus === 'active' && docData.tier === 'premium';
    console.log(`   Status is 'active': ${docData.subscriptionStatus === 'active'}`);
    console.log(`   Tier is 'premium': ${docData.tier === 'premium'}`);
    console.log(`   → User should be premium: ${isPremium}`);

    // 5. Get what subscriptionManager returns
    console.log('5️⃣ Testing subscriptionManager.getUserTier()...');
    const tierData = await subscriptionManager.getUserTier(email);
    console.log('   Returned tier:', tierData.tier);
    console.log('   Full config:', tierData);

    // 6. Get subscription config
    console.log('6️⃣ Testing subscriptionManager.getSubscriptionConfig()...');
    const config = await subscriptionManager.getSubscriptionConfig(email);
    console.log('   Config:', config);

    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('✅ Debug complete!');

    return {
      firestoreData: docData,
      tierData: tierData,
      config: config,
      isPremium: isPremium,
    };

  } catch (error) {
    console.error('❌ Error during debug:', error);
    console.log('Error details:', {
      message: error.message,
      code: error.code,
      stack: error.stack,
    });
    return { error: error.message };
  }
}

// Make available globally in browser console
if (typeof window !== 'undefined') {
  window.debugSubscription = debugSubscription;
}
